import type { LucideIcon } from 'lucide-react';
import { normalizeExternalUrl } from '../../lib/external-url.js';
import { logoUrl } from '../../lib/logo.js';
import type { ApiProjectSource } from '../../lib/projects.js';
import { EntityAvatar } from '../entity-drawer/entity-drawer-shell.js';

export function getProjectSourceAvatarDisplay(latestSource: ApiProjectSource | null | undefined) {
  return {
    href: normalizeExternalUrl(latestSource?.base_url),
    logoSrc: logoUrl(latestSource?.logo_domain ?? latestSource?.base_url),
  };
}

interface ProjectSourceAvatarProps {
  name: string;
  latestSource?: ApiProjectSource | null;
  fallbackIcon: LucideIcon;
  size?: 'sm' | 'md';
}

export function ProjectSourceAvatar({
  name,
  latestSource,
  fallbackIcon,
  size = 'md',
}: ProjectSourceAvatarProps) {
  const display = getProjectSourceAvatarDisplay(latestSource);

  return (
    <EntityAvatar
      src={display.logoSrc}
      alt={name}
      fallbackIcon={fallbackIcon}
      size={size}
      href={display.href}
      hrefLabel={latestSource ? `Open ${latestSource.display_name}` : undefined}
    />
  );
}
